import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostAgentMonthEliteBonusDtlList } from '@/services/wms/commission';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      searchForm: {
        agentMonthCommissionId: this.$route.query.agentMonthCommissionId
      },
      btnLoading: false,
      listRequest: rqtPostAgentMonthEliteBonusDtlList
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};